import React from "react";

const siteUrl = "https://neurosity.co";

export function GuideJsonLd({ frontmatter }) {
  const {
    title,
    description,
    slug,
    faqs,
    howToSteps,
    jsonLdDates
  } = frontmatter;

  const schemas = [];

  // Article schema
  const articleSchema = {
    "@context": "https://schema.org",
    "@type": "Article",
    headline: title,
    description,
    url: `${siteUrl}/guides/${slug}`,
    author: {
      "@type": "Organization",
      name: "Neurosity",
      url: siteUrl
    },
    publisher: {
      "@type": "Organization",
      name: "Neurosity",
      url: siteUrl,
      logo: {
        "@type": "ImageObject",
        url: `${siteUrl}/icon.png`
      }
    },
    mainEntityOfPage: {
      "@type": "WebPage",
      "@id": `${siteUrl}/guides/${slug}`
    }
  };

  if (jsonLdDates?.datePublished) {
    articleSchema.datePublished = jsonLdDates.datePublished;
  }
  if (jsonLdDates?.dateModified) {
    articleSchema.dateModified = jsonLdDates.dateModified;
  }

  schemas.push(articleSchema);

  // FAQ schema
  if (faqs?.length > 0) {
    schemas.push({
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: faqs.map((faq) => ({
        "@type": "Question",
        name: faq.question,
        acceptedAnswer: {
          "@type": "Answer",
          text: faq.answer
        }
      }))
    });
  }

  // HowTo schema
  if (howToSteps?.length > 0) {
    schemas.push({
      "@context": "https://schema.org",
      "@type": "HowTo",
      name: title,
      description,
      step: howToSteps.map((step, i) => ({
        "@type": "HowToStep",
        position: i + 1,
        name: step.name,
        text: step.text
      }))
    });
  }

  return (
    <>
      {schemas.map((schema, i) => (
        <script
          key={i}
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
        />
      ))}
    </>
  );
}
